import request from '../_helpers/request';
import * as constantsConfig from '../constants/config';
import MIMETDb from 'mime-db';
import { LogService } from './log.Service'

export const fileUploadService = {
    AppendQuery,
    UploadToServer,
    uploadFile,
    GetStsToken,
    SaveOssUrlToDB,
    UpdateOssUrlToDb
};

const LOG_PAGE_NAME = "FileUploadService";

var LocalQuery = []; //refName, type (image, video, file), array
//var MIMETypes = require('mime-types')

//存base64String的file
async function uploadFileByBase64(base64String, filename, type, maxSize) {
    var file = transferBase64ToFile(base64String, filename);
    return uploadFile(file, type,maxSize);
}
//base64 -> File
function transferBase64ToFile(dataurl, filename) {
    
    var arr = dataurl.split(','),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[arr.length - 1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
    while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
    }
    if(filename != undefined ){
        filename = filename.replace(/\.[^/.]+$/, '');
    }
    //var extension = mime.split('/')[1]; //[28112024][SJP] STOP getting extensions by slicing the MIME!!!!! It is not accurate!!!!!!!
    const extension = MIMETDb[mime]?.extensions?.[0] || mime.split('/')[1];

    return new File([u8arr], filename + '.' + extension, { type: mime });
}
//存file
function uploadFile(file, type, maxSize) {

    const formData = new FormData();
    formData.append('formFile', file);
    formData.append('type', type);
    formData.append('maxSize', maxSize);
    var url = 'File/UploadFile';

    // 修复：axios.post只接受3个参数(url, data, config)
    // 注意：对于FormData，不需要也不应该手动设置Content-Type
    // request.js的拦截器会自动检测FormData并删除Content-Type，让浏览器自动设置（包含boundary）
    return request.post(url, formData, {
        timeout: 600000 // 10分钟超时，适合大文件上传
        // 不传headers，让request.js拦截器自动处理FormData的Content-Type
    })
    .then(res => {
      if(res.isSuccessful)
      {
        return res;
      }
      else
      {
        throw new Error('文件上传失败：'+res.msg.join(",")+'！');
      }
    })
    .catch(error => {
      // 增强错误日志，便于调试
      console.error('文件上传失败:', {
        fileName: file?.name ?? 'blob',
        fileSize: file?.size,
        fileType: file?.type,
        uploadType: type,
        error: error.message,
        errorCode: error.code,
        response: error.response
      });
      throw error;
    });
}
//加到等待列
function AppendQuery(refName, type, array,maxSize) {
    LocalQuery.push({ refName: refName, type: type, array: array});
}
//上傳等待列的file
async function UploadToServer(vueElement) {

    var finalFileResult= { isSuccessful:true,statusCode:200,msg:[],data:[],maxSize:0 };
    try {
        var finishCnt = 0;
        var totalCnt = 0;
        //console.log("LocalQuery");
        //console.log(LocalQuery);
        const modifiedObjects = LocalQuery.flatMap(section => 
            section.array
                .filter(item => item.modified === true)
                .map(item => ({ ...item, type: section.type }))
        );
        //console.log("modifiedObjects");
        //console.log(modifiedObjects);

        totalCnt = modifiedObjects.length;

        /*
        for (var i = 0; i < LocalQuery.length; i++) {
            var element = LocalQuery[i];
            for (var j = 0; j < element.array.length; j++) {
                var item = element.array[j];
                if (item.modified) {
                    totalCnt += element.array.length;
                }
            }
        }*/
        UploadProgressPopup(vueElement, finishCnt, totalCnt, true);
        for (var i = 0; i < LocalQuery.length; i++) {
            var element = LocalQuery[i];
            //console.log('element');
            //console.log(element.array);
            var maxSize=0;

            var fileResult= { isSuccessful:true,statusCode:200,msg:[],data:null,maxSize:0 };
            //DEBUG=>create error
            //element = null;
            switch (element.type) {
                case 'Image':
                    for (var j = 0; j < element.array.length; j++) {
                        var item = element.array[j];
                        maxSize=item.maxSize; 
                        if (item.modified && item.imageSrc) {
                            var cdnLnk = '';
                            if(item.imageSrc.includes('https://')){
                                cdnLnk = item.imageSrc;
                                fileResult.maxSize=maxSize;
                            } else {
                                //is base64
                               fileResult=await uploadFileByBase64(item.imageSrc, item.FileName, element.type,maxSize);
                               fileResult.maxSize=maxSize;
                               if(fileResult.isSuccessful){
                                    cdnLnk = fileResult.data.cdnLnk;
                               }
                            }
                            item.cdnLnk = cdnLnk;
                            finishCnt += 1;
                            UploadProgressPopup(vueElement, finishCnt, totalCnt);
                        }
                    }
                    break;
                case 'Video':
                    for (var j = 0; j < element.array.length; j++) {
                        var item = element.array[j];
                        if (item.modified) {
                            var videoCdnLnk = '', imgCdnLnk = '';
                            if(item.videoSrc){
                                if(item.videoSrc.includes('https://')){
                                    videoCdnLnk = item.videoSrc;
                                    fileResult.maxSize=maxSize;
                                } else {
                                    maxSize=item.imagemaxSize; 
                                    //is base64
                                    fileResult = await uploadFileByBase64(item.videoSrc, item.FileName, 'Video',maxSize);
                                    fileResult.maxSize=maxSize;
                                    if(fileResult.isSuccessful){
                                        videoCdnLnk = fileResult.data.cdnLnk;
                                    }
                                }
                            }
                            if(item.imageSrc){
                                if(item.imageSrc.includes('https://')){
                                    imgCdnLnk = item.imageSrc;
                                    fileResult.maxSize=maxSize;
                                } else {
                                    maxSize=item.videomaxSize; 
                                    //is base64
                                    fileResult = await uploadFileByBase64(item.imageSrc, item.FileName, 'VideoCapture',maxSize);
                                    fileResult.maxSize=maxSize;
                                    if(fileResult.isSuccessful){
                                        imgCdnLnk = fileResult.data.cdnLnk;
                                    }
                                }
                            }
                            
                            item.videoCdnLnk = videoCdnLnk;
                            item.imgCdnLnk = imgCdnLnk;
                            finishCnt += 1;
                            UploadProgressPopup(vueElement, finishCnt, totalCnt);
                        }
                        // For unmodified videos, preserve existing CDN links
                        // If videoCdnLnk or imgCdnLnk are not set but videoSrc/imageSrc are CDN links, use them
                        else {
                            if (!item.videoCdnLnk && item.videoSrc && item.videoSrc.includes('https://')) {
                                item.videoCdnLnk = item.videoSrc;
                            }
                            if (!item.imgCdnLnk && item.imageSrc && item.imageSrc.includes('https://')) {
                                item.imgCdnLnk = item.imageSrc;
                            }
                        }
                    }
                    break;
                default: // File other than image and video
                    //File Todo
                    for (var j = 0; j < element.array.length; j++) {
                        var item = element.array[j];
                        maxSize=item.maxSize;
                        //var cdnLnk = await uploadFile(item.Src, 'File',10);
                        fileResult = await uploadFile(item.Src, 'File',20);
                        fileResult.maxSize=maxSize;
                        if(fileResult.isSuccessful){
                            cdnLnk = fileResult.data.cdnLnk;
                        }
                        item.cdnLnk = cdnLnk;
                        finishCnt += 1;
                        UploadProgressPopup(vueElement, finishCnt, totalCnt);
                    }
                    break;
            }
            /* Add the element to the finalFileResult */
            finalFileResult.data.push(fileResult);
            /* If the file size is too large, show the popup and return the result */
            if(fileResult.statusCode == 801){
                FinishProgressPopup(vueElement, finishCnt, totalCnt);
                return  SizeExceedPopup(vueElement,finishCnt , totalCnt); 
            }
        }
    
        /* Finish the progress popup */
        FinishProgressPopup(vueElement, finishCnt, totalCnt);
        
        /* Copy the LocalQuery to the resultQuery */
        var resultQuery = LocalQuery.map(item => ({ ...item }));;
        /* Clear the LocalQuery */
        LocalQuery = [];
        finalFileResult.data=resultQuery;
        //console.log("finalFileResult");
        //console.log(finalFileResult);
        /* Return the finalFileResult */
        resultQuery.isSuccessful= finalFileResult.isSuccessful;
        resultQuery.statusCode= finalFileResult.statusCode;
        resultQuery.msg= finalFileResult.msg;
        return resultQuery;

    } catch (error) {
        console.log(error);
        //ErrorPopup(vueElement,error);
        /* Add the LocalQuery to the finalFileResult */
        finalFileResult.data=LocalQuery;
        finalFileResult.isSuccessful= false;
        finalFileResult.msg.push('Upload Failed: '+error.message);
        /* Return the finalFileResult */
        return finalFileResult;
    }

}
//處理中的popup
export function UploadProgressPopup(vueElement, finishCnt, totalCnt, firstPopup) {
    var popupObject = {
        text: vueElement.$t('lbl_EMPBE_UploadProgress') + ': ' + finishCnt + '/' + totalCnt,
        showCancelButton: false,
        allowOutsideClick: false,
        showConfirmButton: false
    };
    if(firstPopup){
        vueElement.$swal(popupObject);
    } else {
        vueElement.$swal.update(popupObject);
    }

}
//處理完成的popup
export function FinishProgressPopup(vueElement, finishCnt, totalCnt) {
    var message = vueElement.$t('lbl_EMPBE_UploadSuccess');
    if (totalCnt > 0) {
        message += ': ' + finishCnt + '/' + totalCnt;
    }
    vueElement.$swal.close();
}
function SizeExceedPopup(vueElement, finishCnt,totalCnt  ){
    var popupObject = {
        text: vueElement.$t('lbl_EMPBE_ProductPhotoDesc') + ': ' + finishCnt + '/' + totalCnt,
        showCancelButton: true,
        allowOutsideClick: false,
        showConfirmButton: false
    };
    return vueElement.$swal(popupObject).then(async (res) => {
        location.reload();
        return { isSuccessful:false,statusCode:801,msg:["Image file larger than 20MB"],data:null,maxSize:0 }

    });;
}

//Error popupObject
function ErrorPopup(vueElement, Error) {
    var message = vueElement.$t('lbl_EMPBE_UploadFailed');
    message += ': ' + Error;

    var popupObject = {
        text: vueElement.$t('lbl_EMPBE_ProductPhotoDesc') + ': ' + finishCnt + '/' + totalCnt,
        showCancelButton: true,
        allowOutsideClick: false,
        showConfirmButton: false
    };
    return vueElement.$swal(popupObject).then(async (res) => {
        location.reload();
        return { isSuccessful:false,statusCode:801,msg:[message],data:null,maxSize:0 }

    });;
}

// //[25042024][SJP] return the value after the user click the button/ close the pop up window
//  function AwaitPopUp(vueElement, Message, ConfirmReturnValue, CancelReturnValue, 
//     allowOutsideClick, showCancelButton, showConfirmButton){
//         var popupObject = {
//             text: Message,
//             showCancelButton: showCancelButton,
//             allowOutsideClick: allowOutsideClick,
//             showConfirmButton: showConfirmButton
//         }      

//         return  vueElement.$swal(popupObject).then(async (res) => {
//             console.log(res)
//             console.log(ConfirmReturnValue)
//             return ConfirmReturnValue
//             // if(res.isConfirmed){
//             //     return ConfirmReturnValue;
//             // }
//             // if(res.isCancelled){
//             //     return CancelReturnValue
//             // }
//             // return CancelReturnValue
    
//         });;
// }

// [20260120][BLK] Get Sts Token for upload file
async function GetStsToken() {
    return request.post('File/GetUploadFileStsToken').then(res => {
        if (!res.isSuccessful) {
            if (res.systemErrorMsg.length) {
                throw new Error(res.SystemErrorMsg[0]);
            }

            throw new Error('Get Sts Token Failed');
        }

        return res.data; 
    });
}
/**
 * @param {number[]} rids - int array
 * @param {Object[]} data - array of objects
 */
async function SaveOssUrlToDB(rids, data, formId) {
    const ridsJson = JSON.stringify(Array.isArray(rids) ? rids : [rids]);
    const dataJson = JSON.stringify(Array.isArray(data) ? data : [data]);

    const logQuery = {
        FormId: formId,
        Action: "SaveOssUrlToDb",
        FormType: "SaveOssUrlToDb",
        ErrorLog: null,
    };
    LogService.LogFormDataWithObj(logQuery, { rids, data });

    return request.post('File/SaveOssUrlToDb', { ridsJson, dataJson }).then(res => {
        if (!res.isSuccessful || res.statusCode !== 200) {
            if (res.systemErrorMsg.length) {
                throw new Error(res.SystemErrorMsg[0]);
            }

            throw new Error('Save OSS URL To DB Failed');
        }
        
        return true;
    });
}

async function UpdateOssUrlToDb(req) {
    if (!req.EmpCompanyId || isNaN(Number(req.EmpCompanyId))) {
        req.EmpCompanyId = 0;
    }

    if (req.EmpCompanyId && typeof req.EmpCompanyId === "string") {
        req.EmpCompanyId = parseInt(req.EmpCompanyId);
    }

    if (!req.EmpProductId || isNaN(Number(req.EmpProductId))) {
        req.EmpProductId = 0;
    }

    if (req.EmpProductId && typeof req.EmpProductId === "string") {
        req.EmpProductId = parseInt(req.EmpProductId);
    }

    const logQuery = {
        FormId: req.EmpCompanyId,
        Action: "UpdateOssUrlToDb",
        FormType: "UpdateOssUrlToDb",
        ErrorLog: null,
    };
    LogService.LogFormDataWithObj(logQuery, req);

    return request.post("File/UpdateOssUrlToDb", req).then((res) => {
        if (!res.isSuccessful || res.statusCode !== 200) {
            if (res.systemErrorMsg.length) {
                throw new Error(res.SystemErrorMsg[0]);
            }

            throw new Error("Update OSS URL To DB Failed");
        }

        return true;
    });
}
